module.exports = __webpack_public_path__ + "static/img/LMM1.0-logo.2c4111b0.svg";